import { Component} from '@angular/core';

@Component({
  selector: 'app-wbmsalinity-vertical-header',
  standalone: false,
  templateUrl: './wbmsalinity-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class WbmSalinityVerticalHeaderComponent {

}
